import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import type { StreetViewBatchJob } from '@citizen-walk/shared-types';
import { db } from '../../lib/firebase';

/**
 * 一括解析ジョブ (`streetViewBatchJobs/{jobId}`) の進捗購読 (2026-07-16 切り出し)。
 *
 * `StreetSurveyBatchPanel.tsx` にインライン実装されていたが、進捗パネルを閉じても
 * ジョブ追跡が失われないよう `jobId` を `StreetSurveyPage.tsx` に引き上げたため、
 * パネル本体と常時表示の進捗バッジの両方から購読できる形に切り出した。
 */
export function useStreetSurveyBatchJob(
  districtId: string,
  jobId: string | null,
  onError?: (error: Error) => void,
): StreetViewBatchJob | null {
  const [job, setJob] = useState<StreetViewBatchJob | null>(null);

  useEffect(() => {
    if (!jobId) {
      setJob(null);
      return;
    }
    const unsub = onSnapshot(
      doc(db, 'districts', districtId, 'streetViewBatchJobs', jobId),
      (snap) => {
        if (snap.exists()) setJob(snap.data() as StreetViewBatchJob);
      },
      (error) => onError?.(error),
    );
    return () => unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtId, jobId]);

  return job;
}
